import Vue from 'vue'
//Vuetify
import vuetify from './plugins/vuetify';
//i18n
import i18n from './i18n'
//Vuex
import store from './store'
//Router
import router from './core/router'
//App
import App from './App.vue'
//Axios
import axios from 'axios'
//Material
import 'material-design-icons/iconfont/material-icons.css'

Vue.prototype.$axios = axios
Vue.config.productionTip = false

//import base components
import upperFirst from 'lodash/upperFirst'
import camelCase from 'lodash/camelCase'
//只导入 base.*.vue 的公共基本组件。
const requireComponent = require.context(
  './core/components',
  false,
  /base\.\w+\.vue$/
)
requireComponent.keys().forEach(fileName => {
  const componentConfig = requireComponent(fileName)
  const componentName = upperFirst(
    camelCase(
      fileName
        .split('/')
        .pop()
        .replace(/\.\w+$/, '')
    )
  )
  Vue.component(
    componentName,
    componentConfig.default || componentConfig
  )
})

//routerBefore
router.beforeEach((to, from, next) => {
  if (to.meta.title) {
    //标题
    if (location.toString().indexOf('localhost') > -1 || location.toString().indexOf('dev.makjust.com') > -1) {
      //测试域名
      document.title = to.meta.title + ' - MAKjust.Dev | 空想派开发版'
    } else {
      //正式域名
      document.title = to.meta.title + ' - MAKjust | 空想派'
    }
  }
  if (location.toString().indexOf('dev.makjust.cc') > -1) {
    //Developer
    document.title = to.meta.title + ' - MAKjust 开发者中心'
    next({path: '/home'})
  } else {
    if (to.meta.auth) {
      //需要进行鉴权
      if (!/^[A-Za-z0-9]{25}$/gi.test(localStorage.getItem('ms-user-sessionToken')) && location.toString().indexOf('localhost') < 0) {
        //如果没有缓存25位sessionToken(且非测试用地址)即为未登录
        next({
          path: '/account/login',
          query: { redirect: to.fullPath }
        });
      } else {
        next();
      }
    } else {
      next();
    }
  }
})

new Vue({
  router,
  store,
  vuetify,
  i18n,
  render: h => h(App),
}).$mount('#app')
